/*
 * Starea unui rand din „Cererile mele", citita intr-un singur loc.
 *
 * Doua intrebari, puse din trei locuri - eticheta din tabel, filtrul de stare
 * si numarul din meniu: ce stare ARATA randul, si mai asteapta ceva sau s-a
 * terminat. Scrise de doua ori, filtrul ar fi oferit o stare si eticheta ar fi
 * aratat alta - exact asa a stat filtrul pana acum: oferea `submitted` (starea
 * magazinului) pe un rand care arata „Pending Approval" (starea tichetului).
 */

import { toneForState } from '../components/Badge';
import { isDirectTicket, type FeedRow } from '../api/types';

/** Starea pe care o deseneaza eticheta randului - si dupa care se filtreaza. */
export function displayState(row: FeedRow): string | null {
  if (isDirectTicket(row)) return row.status ?? null;

  return row.ticket_state ?? row.state ?? row.status ?? null;
}

/*
 * `status_type` din fluxul tichetului: 1 activ, 2 rezolvat (fixed), 3 inchis
 * (final). Vezi Views::$statusTypes in api.
 */
const DONE_TYPES = new Set<unknown>([2, 3, 'fixed', 'final']);

/**
 * S-a terminat randul - rezolvat, inchis, respins sau anulat?
 *
 * Intai ce spune api-ul pe fata (`status_type`, `open`, `ticket_state_type`);
 * numai cand lipseste - un api mai vechi - se ghiceste dupa numele starii, cu
 * aceleasi tonuri ca eticheta. Un rand despre care nu se stie nimic ramane
 * deschis: un numar prea mare se vede, unul prea mic ascunde o cerere.
 */
export function isFinished(row: FeedRow): boolean {
  if (isDirectTicket(row)) {
    if (row.status_type !== null && row.status_type !== undefined) {
      return DONE_TYPES.has(row.status_type);
    }
  } else {
    if (typeof row.open === 'boolean') return !row.open;
    if (row.ticket_state_type) return DONE_TYPES.has(row.ticket_state_type);
  }

  const tone = toneForState(displayState(row));

  return tone === 'done' || tone === 'cancelled';
}
